import { Component, OnInit, ViewChild } from "@angular/core";
import { ColumnTypes } from "src/app/shared/Models/enums/ColumnTypeEnum";
import { FilterableTableComponent } from "src/app/shared/table/filterable-table.component";
import { Table } from "primeng/table";
import { SaveStateTypeEnum } from "src/app/shared/Models/enums/SaveStateTypeEnum";
import { ToastService } from "src/app/shared/toast.service";
import { DeviceCheckService } from "src/app/core/survey/shared/services/device-check.service";
import { SettingDto } from "../../models/SettingDto";
import { SettingType } from "../../models/SettingType.enum";
import { GeneralSettingsService } from "../../services/general-settings.service";
import { first } from "rxjs/operators";

@Component({
  selector: "app-admin-panel-general-settings",
  templateUrl: "./admin-panel-general-settings.component.html",
  styleUrls: ["./admin-panel-general-settings.component.scss"],
})
export class AdminPanelGeneralSettingsComponent
  extends FilterableTableComponent<SettingDto>
  implements OnInit
{
  @ViewChild("dtc") dataTable: Table;

  saveStates = SaveStateTypeEnum;

  scrollOffsetLandscape: number = 245;
  scrollOffsetPortrait: number = 245;

  allCols = [
    {
      field: "settingTypeName",
      header: "SETTING TYPE",
      visibleOnPortrait: true,
      hasFilter: true,
      type: ColumnTypes.STRING,
      template: "default",
      filterSearch: true,
      hasEmptyValue: false,
    },
    {
      field: "settingValue",
      header: "SETTING VALUE",
      visibleOnPortrait: true,
      hasFilter: false,
      type: ColumnTypes.STRING,
      template: "default",
      hasEmptyValue: false,
    },
  ];
  constructor(
    private _toastService: ToastService,
    private _deviceCheckService: DeviceCheckService,
    private _generalSettingsService: GeneralSettingsService
  ) {
    super(_toastService, _deviceCheckService);
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.getGeneralSettings();
  }

  changeGeneralSetting(generalSetting: SettingDto) {
    generalSetting.state = SaveStateTypeEnum.ongoing;

    var updatedSetting = new SettingDto();
    updatedSetting.settingValue = generalSetting.settingValue;
    updatedSetting.settingDataType = generalSetting.settingDataType;
    updatedSetting.settingType = generalSetting.settingType;

    if (generalSetting.settingDataType === "boolean")
      updatedSetting.settingValue = generalSetting.settingBoolValue.toString();

    //do stuff to save the changes
    this._generalSettingsService.changeGeneralSetting(updatedSetting).subscribe(
      (res: any) => {
        generalSetting.state = SaveStateTypeEnum.done;
        setTimeout(() => {
          generalSetting.state = SaveStateTypeEnum.unkown;
        }, 5000);
      },
      (err) => {
        generalSetting.state = SaveStateTypeEnum.failed;
        this.showErrorWhileChangingGeneralSetting;
      }
    );
  }

  canShowStateInfo(generalSetting: SettingDto): boolean {
    return (
      generalSetting &&
      (generalSetting.state == SaveStateTypeEnum.ongoing ||
        generalSetting.state == SaveStateTypeEnum.failed ||
        generalSetting.state == SaveStateTypeEnum.done)
    );
  }

  public getSettingTypeName(typeId) {
    return SettingType[typeId];
  }

  private getGeneralSettings() {
    this._generalSettingsService
      .getGeneralSettings()
      .pipe(first())
      .subscribe(
        (res) => {
          res.forEach((x) => {
            x.settingTypeName = this.getSettingTypeName(x.settingType);
            if (x.settingDataType === "boolean")
              x.settingBoolValue = x.settingValue.toLowerCase() === "true";
          });
          this.tableValues = res;
          this.globalFilter$.next(this.globalFilter);
        },
        () => this.showErrorWhileGettingGeneralSettings()
      );
  }

  private showErrorWhileChangingGeneralSetting() {
    this.toastService.showErrorToast(
      $localize`Something went wrong`,
      $localize`Something went wrong while changing the setting.`
    );
  }

  private showErrorWhileGettingGeneralSettings() {
    this.toastService.showErrorToast(
      $localize`Something went wrong`,
      $localize`Something went wrong while retrieving the general settings.`
    );
  }
}
